

export default {
  name: "ImageView",
  props: ["ImgSrc", "AltName"],
};
